export const INSIGHTS_PAGE_SIZE_WEEKS = 8

function weekDate(value: string): Date {
  return new Date(`${value}T12:00:00.000Z`)
}

export function formatInsightNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

export function formatWeek(value: string): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'Europe/Amsterdam',
  }).format(weekDate(value))
}

export function formatPeriodLabel(weekStarts: string[]): string {
  if (weekStarts.length === 0) return 'Selected weeks'

  const start = weekDate(weekStarts[0])
  const end = weekDate(weekStarts[weekStarts.length - 1])
  end.setUTCDate(end.getUTCDate() + 6)

  const startLabel = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'Europe/Amsterdam',
  }).format(start)
  const endLabel = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'Europe/Amsterdam',
  }).format(end)

  return `${startLabel} – ${endLabel}`
}

export function olderWeekOffset(currentOffset: number): number {
  return currentOffset + INSIGHTS_PAGE_SIZE_WEEKS
}

export function newerWeekOffset(currentOffset: number): number {
  return Math.max(0, currentOffset - INSIGHTS_PAGE_SIZE_WEEKS)
}
